import React from 'react';

function LicenseText({ licenseType }) {

    const printlicenseText = () => {
        let licenseText = "";
        switch (licenseType) {
            case "MIT":
                licenseText = (
                    <div className="o-page-wrap o-page-wrap--small">
                        <div className="o-component-wrapper">
                            <p className="u-mt">
                                View license: <a target="_blank" rel="noopener noreferrer" href="https://opensource.org/licenses/mit-license.php">MIT License</a>
                            </p>
                            <p>
                                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                                associated documentation files (the Software), to deal in the Software without
                                restriction, including without limitation the rights to use, copy, modify, merge, publish,
                                distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the
                                Software is furnished to do so, subject to the following conditions:The above copyright notice
                                and this permission notice shall be included in all copies or substantial portions of the
                            Software.<br />
                            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
                            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
                            AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                            DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                        </p>
                        </div>
                    </div>
                );
                break;

            case "ISC":
                licenseText = (
                    <div className="o-page-wrap o-page-wrap--small">
                        <div className="o-component-wrapper">
                            <p className="u-mt">View license: <a target="_blank" rel="noopener noreferrer" href="https://www.isc.org/downloads/software-support-policy/isc-license/">ISC</a>
                            </p>
                            <p>ISC License: Copyright © 2004-2013 by Internet Systems Consortium, Inc. (ISC) Copyright ©
                            1995-2003 by Internet
                            Software Consortium Permission to use, copy, modify, and/or distribute this software for any purpose
                            with or without
                            fee is hereby granted, provided that the above copyright notice and this permission notice appear in
                            all copies.<br />
                            THE SOFTWARE IS PROVIDED "AS IS" AND ISC DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS
                            SOFTWARE INCLUDING ALL IMPLIED
                            WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL ISC BE LIABLE FOR ANY SPECIAL, DIRECT,
                            INDIRECT, OR CONSEQUENTIAL
                            DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
                            OF CONTRACT, NEGLIGENCE
                            OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
                            SOFTWARE.</p>
                        </div>
                    </div>
                );
                break;

            case "BSD":
                licenseText = (
                    <div className="o-page-wrap o-page-wrap--small">
                        <div className="o-component-wrapper">
                            <p className="u-mt">View license: <a target="_blank" rel="noopener noreferrer" href="https://opensource.org/licenses/BSD-2-Clause">BSD
                            License</a>
                            </p>
                            <p>Copyright YEAR COPYRIGHT HOLDER Redistribution and use in source and binary forms, with or without
                            modification, are permitted provided
                            that the following conditions are met: 1. Redistributions of source code must retain the above
                            copyright notice, this list of conditions
                            and the following disclaimer. 2. Redistributions in binary form must reproduce the above copyright
                            notice, this list of conditions and
                            the following disclaimer in the documentation and/or other materials provided with the distribution.<br />
                            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
                            EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
                            LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
                            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
                            HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
                            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
                            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
                            INTERRUPTION) HOWEVER CAUSED AND ON ANY
                            THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
                            OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
                            THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.</p>
                        </div>
                    </div>
                );
                break;

            default:
                break;
        }

        return licenseText;

    }

    return (
        printlicenseText()
    );
}

export default LicenseText;